import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Mail, MapPin, Phone } from 'lucide-react';
import { Logo } from '../../../shared/ui/logo';
import { socials } from '../config';

import styles from './footer.module.css';

export function Footer() {
	const intl = useIntl();

	return (
		<footer className={styles.footer}>
			<div className={styles.container}>
				<div className={styles.top}>
					<div className={styles.brand}>
						<Logo />
						<p className={styles.slogan}>
							{intl.formatMessage({ id: 'heroSectoinId3' })}
						</p>
						<ul className={styles.socials}>
							{socials.map(social => (
								<li key={social.id}>
									<a
										href={social.href}
										className={styles.social}
										aria-label={social.label}
										target='_blank'
										rel='noreferrer'
									>
										<social.icon size={18} strokeWidth={1.6} aria-hidden />
									</a>
								</li>
							))}
						</ul>
					</div>

					<nav className={styles.columns} aria-label='Footer'>
						<div className={styles.column}>
							<h3 className={styles.columnTitle}>
								{intl.formatMessage({ id: 'navBarId5' })}
							</h3>
							<Link to='/#features' className={styles.link}>
								{intl.formatMessage({ id: 'FooterId1' })}
							</Link>
							<Link to='/#how-it-works' className={styles.link}>
								{intl.formatMessage({ id: 'HowItWorksId2' })}
							</Link>
						</div>

						<div className={styles.column}>
							<h3 className={styles.columnTitle}>
								{intl.formatMessage({ id: 'navBarId1' })}
							</h3>
							<Link to='/terms' className={styles.link}>
								{intl.formatMessage({ id: 'FooterId2' })}
							</Link>
							<Link to='/privacy' className={styles.link}>
								{intl.formatMessage({ id: 'FooterId3' })}
							</Link>
							<Link to='/about' className={styles.link}>
								{intl.formatMessage({ id: 'navBarId1' })}
							</Link>
						</div>

						<div className={styles.column}>
							<h3 className={styles.columnTitle}>
								{intl.formatMessage({ id: 'FooterId4' })}
							</h3>
							<a className={styles.contact} href='tel:+37495747445'>
								<Phone size={16} strokeWidth={1.6} aria-hidden />
								<span>+37495747445</span>
							</a>
							<a href='mailto:info@finpath.am' className={styles.contact}>
								<Mail size={16} strokeWidth={1.6} aria-hidden />
								<span>info@finpath.am</span>
							</a>
							<p className={styles.contact}>
								<MapPin size={16} strokeWidth={1.6} aria-hidden />
								<span>{intl.formatMessage({ id: 'FooterId5' })}</span>
							</p>
						</div>
					</nav>
				</div>

				<div className={styles.bottom}>
					<p>{intl.formatMessage({ id: 'FooterId6' })}</p>
				</div>
			</div>
		</footer>
	);
}
